/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Bot_ContactInputs */

const en_bot_contact = /** @type {(inputs: Bot_ContactInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Contact: ${i?.email}`)
};

const id_bot_contact = /** @type {(inputs: Bot_ContactInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kontak: ${i?.email}`)
};

/**
* | output |
* | --- |
* | "Contact: {email}" |
*
* @param {Bot_ContactInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_contact = /** @type {((inputs: Bot_ContactInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_ContactInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_contact(inputs)
	return en_bot_contact(inputs)
});